import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAdminMode } from "@/lib/adminState";
import { AD_CONFIG, isAdminRoute } from "@/lib/ads";

export const NativeBannerAd = ({ className = "" }) => {
  const ref = useRef(null);
  const { pathname } = useLocation();
  const adminMode = useAdminMode();
  const disabled = adminMode || isAdminRoute(pathname);

  useEffect(() => {
    if (disabled) return;
    const host = ref.current;
    if (!host) return;
    // Don't double-inject if the component remounts in StrictMode.
    if (host.dataset.injected === "true") return;
    host.dataset.injected = "true";

    const div = document.createElement("div");
    div.id = AD_CONFIG.nativeBannerContainerId;
    host.appendChild(div);

    const s = document.createElement("script");
    s.async = true;
    s.setAttribute("data-cfasync", "false");
    s.src = AD_CONFIG.nativeBannerSrc;
    host.appendChild(s);
  }, [disabled]);

  if (disabled) return null;
  return (
    <div
      ref={ref}
      data-xr-ad="native"
      className={`xr-ad-native my-8 w-full overflow-hidden md:my-10 ${className}`}
    />
  );
};

export default NativeBannerAd;
